module.exports = "<button class=\"btn btn-light btn-sm\" (click)=\"openDetails()\" title=\"Info for developers\"><i class=\"fa fa-flask\"></i></button>\r\n"